import script from "./ResumeBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResumeBase.vue?vue&type=script&setup=true&lang=ts"

import "./ResumeBase.vue?vue&type=style&index=0&id=0b602df2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b602df2"]])

export default __exports__